export enum StripePaymentMethod {
  CARD = 'card',
  SEPA_DEBIT = 'sepa_debit',
}

export interface StripePaymentConfigDto {
  methods: StripePaymentMethod[]
  privateKey: string
  publicKey: string
}

export type PaymentConfigsDto = {
  stripe?: StripePaymentConfigDto
}
